import React from 'react';
import {
  ModalInfoContainer,
  ModalInfoContent,
  ModalInfoHead,
  ModalInfoBody,
  ModalInfoBodyIcon,
  ModalInfoBodyLabel
} from './styles';
import { IoClose } from 'react-icons/io5';
import colors from '../../assets/styles/colors';

const ModalInfoErrors = ({ id, bodyIcon, backgroundIcon }) => {
  function closeModalErrores(){
    document.getElementById("ContainerModalInfoErrors").style.opacity = '0';
    document.getElementById("ContainerModalInfoErrors").style.height = '0';
    document.getElementById("ContainerModalInfoErrors").style.overflow = 'hidden';
  }
  return (
    <ModalInfoContainer id="ContainerModalInfoErrors">
      <ModalInfoContent>
        <ModalInfoHead>
          <IoClose size={26} color={colors.textSecondary} onClick={() => closeModalErrores()} id="close-icon" />
        </ModalInfoHead>
        <ModalInfoBody>
          <ModalInfoBodyIcon backgroundIcon={backgroundIcon}>
            {bodyIcon}
          </ModalInfoBodyIcon>
          <ModalInfoBodyLabel id="TitleModalInfoErrors">
          </ModalInfoBodyLabel>
        </ModalInfoBody>
      </ModalInfoContent>
    </ModalInfoContainer>
  )
}

export default ModalInfoErrors
